import React, { useEffect, useState } from 'react';
import './global.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import Layout from './pages/Layout';

import LandingPage from './pages/public/LandingPage';
import MajorList from './pages/admin/MajorList';
import Publish from './pages/admin/publish/Publish';
import { parseLocStore, setLocal } from './lib/utils';
import ContentManagement from './pages/admin/detail/ContentManagment';
import LoginWsFed from './auth/LoginWsFed';
import CallbackWsFed from './auth/CallbackWsFed';
import NotFound from './NotFound';
import ProtectedAdmin from './ProtectedAdmin';
import Home from './pages/Home';
import Redirect from './Redirect';

const App = () => {
  const [authenticated, setAuthenticated] = useState<boolean>(
    parseLocStore('authenticated') || false
  );
  const [userInfo, setUserInfo] = useState<any | null>(
    parseLocStore('userInfo')
  );
  const [isAdmin, setIsAdmin] = useState(parseLocStore('isAdmin') || false);

  const location = useLocation();
  const [returnUrl, setReturnUrl] = useState(parseLocStore('returnUrl') || '');

  useEffect(() => {
    if (location.pathname.includes('admin')) {
      setReturnUrl(location.pathname);
      setLocal('returnUrl', location.pathname);
    }
  }, [location.pathname]);

  const AppRoutes = [
    {
      path: '*',
      element: <NotFound />,
    },
    // {
    //   path: '/',
    //   element: <Home />,
    // },
    {
      path: '/majors/:id',
      element: <LandingPage />,
    },
    // {
    //   path: '/',
    //   element: (
    //     <Redirect authenticated={authenticated} redirectUrl="admin/majors" />
    //   ),
    // },
    // {
    //   path: '/login',
    //   element: <LoginWsFed authenticated={authenticated} />,
    // },
    // {
    //   path: '/callback',
    //   element: (
    //     <CallbackWsFed
    //       isAdmin={isAdmin}
    //       returnUrl={returnUrl}
    //       authenticated={authenticated}
    //       setAuthenticated={setAuthenticated}
    //       userInfo={userInfo}
    //       setUserInfo={setUserInfo}
    //     />
    //   ),
    // },
    // {
    //   path: '/admin/majors',
    //   element: (
    //     <ProtectedAdmin
    //       userInfo={userInfo}
    //       returnUrl="admin/majors"
    //       isAuthenticated={authenticated}
    //       isAdmin={isAdmin}
    //       element={MajorList}
    //     />
    //   ),
    // },
    // {
    //   path: '/admin/majors/:id',
    //   element: (
    //     <ProtectedAdmin
    //       userInfo={userInfo}
    //       returnUrl="admin/majors/:id"
    //       isAuthenticated={authenticated}
    //       isAdmin={isAdmin}
    //       element={ContentManagement}
    //     />
    //   ),
    // },
    // {
    //   path: '/admin/publish/majors/:id',
    //   element: (
    //     <ProtectedAdmin
    //       userInfo={userInfo}
    //       returnUrl="admin/publish/majors/:id"
    //       isAuthenticated={authenticated}
    //       isAdmin={isAdmin}
    //       element={Publish}
    //     />
    //   ),
    // },
  ];

  useEffect(() => {
    const inAdminGroup = userInfo?.find(
      (attribute: { type: string; value: string }) =>
        attribute.value === 'DegreemapAdmin'
    );
    if (inAdminGroup) {
      setIsAdmin(true);
    }
  }, [userInfo]);

  return (
    <Layout userInfo={userInfo}>
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return <Route key={index} {...rest} element={element} />;
        })}
      </Routes>
    </Layout>
  );
};

export default App;
